// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__BnQsR","col":"styles_col__2PqYG"};